import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit} from '@angular/core';

@Directive({
  selector: '[appCharLength]',
  standalone: true
})
export class CharLength implements OnInit, OnDestroy {
  @Input('appCharLength') maxLength = 150;
  @Input() showCounter = true;

  private countElement?: HTMLDivElement;

  constructor(
    private elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const input = this.elementRef.nativeElement;

    input.maxLength = this.maxLength;

    if (this.showCounter) {
      this.initializeCounterElement();
      this.updateCounter(input.value.length);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.updateCounter(input.value.length);
  }

  ngOnDestroy(): void {
    this.countElement?.remove();
  }

  private updateCounter(length: number): void {
    this.countElement &&
      (this.countElement.textContent =
        `${length}/${this.maxLength} characters`);
  }

  private initializeCounterElement(): void {
    this.countElement = document.createElement('div');
    this.countElement.classList.add(
      'mt-1',
      'text-xs',
      'text-right',
      'text-gray-400',
      'font-light'
    );

    this.elementRef.nativeElement.insertAdjacentElement(
      'afterend',
      this.countElement
    );
  }
}
